import React, { useState, useEffect } from "react";
import Control from "../../common/Control";
import { Link } from "react-router-dom";
import useStore from "../../../context/useStore";
import Loader from "../../common/Loader";
import Axios from "axios";
import { api_url } from "../../../config";
import { DateTime } from "luxon";
import { toast } from "react-toastify";
import LandingCD from "./LandingCD";
import LandingPE from "./LandingPE";
import LandingML from "./LandingML";
import "./parcours.scss";

const initialDays = [
  { id: 1, name: "Lundi", morning: true, evening: false },
  { id: 2, name: "Mardi", morning: true, evening: false },
  { id: 3, name: "Mercredi", morning: true, evening: false },
  { id: 4, name: "Jeudi", morning: true, evening: false },
  { id: 5, name: "Vendredi", morning: true, evening: false },
  { id: 6, name: "Samedi", morning: true, evening: false },
];
const initialMoments = [
  { id: 1, name: "Matin" },
  { id: 2, name: "Après-midi" },
];

const FormRdv = ({
  rdspId,
  userData,
  formData,
  setRdvTaken = false,
  hasDroit,
  isConjoint,
  origin = "",
  // Niveau des titres d'état : h2 sous le titre d'étape du parcours, h3 dans
  // une section de l'espace allocataire (dont le titre est déjà un h2).
  niveauTitre = 2,
}) => {
  const Titre = niveauTitre === 3 ? "h3" : "h2";
  const [state, dispatch] = useStore();
  const constants = state.constants.items;
  const [organism, setOrganism] = useState(false);
  const [sites, setSites] = useState(false);
  const [rdvs, setRdvs] = useState(false);
  const [site, setSite] = useState(false);
  const [rdv, setRdv] = useState(false);
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [formRdv, setFormRdv] = useState(false);
  const [countSel, setCountSel] = useState(0);
  const [displayAllRdv, setDisplayAllRdv] = useState(false);
  const [timeSelected, setTimeSelected] = useState({
    days: [],
  });
  const [days, setDays] = useState(initialDays);
  const [rdvsLoading, setRdvsLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // Change à chaque nouvelle proposition pour rejouer l'animation d'apparition.
  const [proposalKey, setProposalKey] = useState(0);

  // Question 16 du RDSP (situation de couple) : absente de certains
  // questionnaires, d'où la garde — sans elle, le récapitulatif plantait.
  const conjointAnswer =
    formData && Array.isArray(formData.rdsp)
      ? formData.rdsp.find((rd) => rd.question == 16) // eslint-disable-line eqeqeq
      : null;
  const hasConjointToDeclare =
    !!conjointAnswer &&
    [1, 2].includes(conjointAnswer.value) &&
    userData.origin !== "SID" &&
    !isConjoint;

  useEffect(() => {
    if (hasDroit && rdspId) {
      Axios.get(api_url + "rdsp/" + rdspId + "/orientation")
        .then((res) => {
          setOrganism(res.data.organization);
          setSites(res.data.sites);
          if (res.data.sites.length == 1) {
            setSite(res.data.sites[0].id);
          }
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            setErrors(err.response.data);
          }
        });
    }
  }, [hasDroit]);
  useEffect(() => {
    if (site) {
      setRdv(false);
      setDisplayAllRdv(false);
      setRdvsLoading(true);
      Axios.post(api_url + "slotcalendars/sites/" + site, {
        userRecipientId: userData.id,
      })
        .then((res) => {
          setRdvs(res.data);
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            setErrors(err.response.data);
          }
        })
        .then(() => {
          setRdvsLoading(false);
        });
    }
  }, [site]);

  useEffect(() => {
    if (rdvs && rdvs.length > 0) {
      reCalcDays();
      setRdv(rdvs[0].id);
    }
  }, [rdvs]);

  useEffect(() => {
    if (countSel >= 3) {
      setRdv(false);
      setDisplayAllRdv(true);
    }
  }, [countSel]);

  useEffect(() => {
    setRdv(false);
  }, [timeSelected]);

  function reCalcDays() {
    var dys = JSON.parse(JSON.stringify(days));
    dys = dys.filter((d) => {
      if (
        rdvs.find((r) => {
          var daystart = DateTime.fromISO(r.start).weekday;
          if (daystart == d.id) {
            return true;
          }
        })
      ) {
        return d;
      }
    });
    setDays(dys);
  }

  function save() {
    if (Object.keys(errors).length === 0 && errors.constructor === Object) {
      var selRdv = rdvs.find((r) => r.id == rdv);
      selRdv.comment = message;
      setIsLoading(true);
      Axios.patch(api_url + "slotcalendars/recipients/" + userData.id, selRdv)
        .then((res) => {
          setFormRdv({
            rdv: selRdv,
            site: site,
          });
          toast.success("Votre RDV a bien été enregistré");
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            setErrors(err.response.data);
          }
        })
        .then(() => {
          setIsLoading(false);
        });
      //save
      // setFormRdv({
      //   site: 1,
      //   rdv: 2,
      // });
    }
  }
  function setNextRdv() {
    var currentIndex = null;
    rdvs.forEach((r, rk) => {
      if (r.id == rdv) {
        currentIndex = rk;
      }
    });
    if (currentIndex + Math.floor((rdvs.length - 1) / 2) > rdvs.length - 1) {
      currentIndex = 0;
    } else {
      currentIndex += Math.floor((rdvs.length - 1) / 2);
    }
    setRdv(rdvs[currentIndex].id);
    setCountSel(countSel + 1);
    setProposalKey(proposalKey + 1);
  }
  function updateTimeSelected(e) {
    var { name, value } = e.target;
    var ev = JSON.parse(JSON.stringify(timeSelected));

    if (ev[name].includes(value)) {
      ev[name] = ev[name].filter((v) => v != value);
    } else {
      ev[name].push(value);
    }

    setTimeSelected(ev);
  }

  const siteRetenu = formRdv && sites ? sites.find((s) => s.id == formRdv.site) : null; // eslint-disable-line eqeqeq

  return (
    <>
      {!hasDroit ? (
        <div className="etat-final" role="status">
          <span className="etat-final__icone" aria-hidden="true">
            <i className="fa fa-check" />
          </span>
          <div>
            <Titre className="etat-final__titre">Vos réponses sont enregistrées</Titre>
            <p>
              Vous avez enregistré les données nécessaires à la mise en œuvre de votre droit à
              l'accompagnement lié au bénéfice du RSA.
            </p>
            <p>
              Votre demande sera traitée dans les meilleurs délais et en fonction de votre situation, vous
              recevrez par mail les informations utiles pour poursuivre vos démarches.
            </p>
          </div>
        </div>
      ) : !organism || isLoading ? (
        Object.keys(errors).length ? (
          <div className="alert alert-info">{errors.other}</div>
        ) : rdspId ? (
          <Loader text="Chargement des informations" />
        ) : (
          <div className="text-center">
            <Link className="btn btn-primary" to="/">
              Accéder à mon espace
            </Link>
          </div>
        )
      ) : organism.slugName == "CD" ? (
        <LandingCD />
      ) : organism.slugName == "PE" ? (
        <LandingPE />
      ) : organism.slugName == "ML_NORD" ? (
        <LandingML url="https://missionlocalenord.re/preinscription" />
      ) : organism.slugName == "ML_SUD" ? (
        <LandingML url="https://missionlocalesud.re/contactez-nous/" />
      ) : organism.slugName == "ML_EST" ? (
        <LandingML url="https://docs.google.com/forms/d/e/1FAIpQLSewC4h9nEpJa2kQc-NAfnR4lDjndczNNMLLK1c-UPeNJeB3DA/viewform" />
      ) : organism.slugName == "ML_OUEST" ? (
        <LandingML url="https://mio-reunion.re/preinscription-a-la-mio/" />
      ) : (
        <div className="rdv-choix">
          {!formRdv ? (
            <>
              <div className="etat-final rdv-choix__intro">
                <span className="etat-final__icone" aria-hidden="true">
                  <i className="fa fa-check" />
                </span>
                <div>
                  <Titre className="etat-final__titre">Votre questionnaire est terminé</Titre>
                  <p>
                    Votre demande de RSA est en cours de traitement. Une fois votre demande étudiée,{" "}
                    <strong>
                      vous serez contacté(e) par un agent pour vous proposer un rendez-vous afin de définir
                      le cadre de votre accompagnement avec un professionnel.
                    </strong>
                  </p>
                  <p>
                    Ce rendez-vous est obligatoire. Dans l'attente, vous pouvez accéder à des premiers
                    services sur votre espace personnel France Travail et vous rendre sur le site de la
                    CAF pour suivre l'avancée de votre demande de RSA.
                  </p>
                </div>
              </div>
              {sites && (
                <Control
                  label="Choisissez un lieu pour votre rendez-vous"
                  type="select"
                  name="site"
                  datas={sites}
                  dataIndex={"id"}
                  dataLabel={"name"}
                  value={site}
                  change={(e) => setSite(e.target.value)}
                  error={errors}
                />
              )}
              {rdvsLoading && <Loader text="Chargement des rendez-vous disponibles" />}
              {site && rdvs.length ? (
                displayAllRdv ? (
                  <>
                    <Control
                      label="Quels jours de la semaine êtes-vous disponible ?"
                      type="checkBtnList"
                      btnInline={true}
                      name="days"
                      datas={days}
                      itemClassName={"btn-sm"}
                      value={timeSelected.days}
                      change={updateTimeSelected}
                    />

                    {timeSelected.days.length > 0 && (
                      <Control
                        label="Choisissez la date de rendez-vous"
                        type="btnList"
                        datas={rdvs.filter((r) => {
                          var timestart = DateTime.fromISO(r.start).weekday;

                          if (timeSelected.days.includes(timestart)) return true;
                          return false;
                        })}
                        dataIndex="id"
                        dataLabel="label"
                        name="rdv"
                        change={(e) => setRdv(e.target.value)}
                        value={rdv}
                      />
                    )}
                  </>
                ) : rdv ? (
                  <>
                    <div className="form-group rdv-proposal-group">
                      <p className="control-label mb-2">Date de rendez-vous proposée</p>
                      <div className="btn-group">
                        <div
                          key={"proposal-" + proposalKey}
                          className="btn btn-default active rdv-proposal animated faster fadeInRight"
                          style={{ animationDuration: "200ms" }}
                          role="status"
                        >
                          <p style={{ width: "93%", margin: 0 }}>{rdvs.find((r) => r.id == rdv).label}</p>
                          <i className="fa fa-check ml-2" aria-hidden="true"></i>
                        </div>
                      </div>
                    </div>

                    <button type="button" className="btn btn-link w-100 rdv-other" onClick={setNextRdv}>
                      Choisir une autre date de rendez-vous
                    </button>
                  </>
                ) : null
              ) : !rdvsLoading ? (
                <div className="alert alert-info">Aucun rendez-vous disponible pour le moment</div>
              ) : null}
              {rdv && (
                <>
                  <Control
                    label="Souhaitez-vous laisser un message à la personne qui vous accueillera ?"
                    name="message"
                    value={message}
                    change={(e) => setMessage(e.target.value)}
                    error={errors}
                  />
                  {Object.entries(errors).map(([key, err]) => (
                    <div key={key} role="alert" className="text-danger font-weight-bold mb-2">
                      {err}
                    </div>
                  ))}
                  <button type="button" onClick={save} className="btn btn-primary w-100 rdv-confirm">
                    Valider ce rendez-vous {rdvs.find((r) => r.id == rdv).label}
                  </button>
                </>
              )}
            </>
          ) : (
            <>
              <div className="rdv-confirmation" role="status">
                <Titre className="rdv-confirmation__titre">
                  <i className="fa fa-calendar-check" aria-hidden="true" />
                  Votre rendez-vous est enregistré
                </Titre>
                <dl>
                  <dt>Date</dt>
                  <dd>{formRdv.rdv.label}</dd>
                  <dt>Lieu</dt>
                  <dd>
                    {siteRetenu &&
                      `${siteRetenu.name} - ${siteRetenu.address} ${siteRetenu.location.postalCode} ${siteRetenu.location.name}`}
                  </dd>
                  <dt>À prévoir</dt>
                  <dd>Merci de vous munir de votre PASS'ORIENTATION disponible dans votre espace.</dd>
                </dl>
              </div>

              {!state.auth.isAuthenticated && (
                <ul className="rdv-suite">
                  {hasConjointToDeclare && (
                    <li>
                      <p>Vous avez un conjoint ? Merci de remplir le questionnaire le concernant.</p>
                      <a
                        href={`/rdsp${origin.length ? "?o=" + origin + "&co=1" : "?co=1"}`}
                        target="_BLANK"
                        rel="noopener noreferrer"
                        className="btn btn-ghost"
                      >
                        Saisir le second questionnaire
                        <span className="sr-only"> (nouvelle fenêtre)</span>
                      </a>
                    </li>
                  )}
                  <li>
                    <p>
                      Dès à présent suivez votre parcours RSA au sein de la CAF de la Réunion sur votre
                      espace allocataire E-SPOAR.
                    </p>
                    <Link to="/" onClick={setRdvTaken ? setRdvTaken : () => {}} className="btn btn-primary">
                      Mon espace E-SPOAR
                    </Link>
                  </li>
                </ul>
              )}
            </>
          )}
          {errors.other && !rdv && (
            <p role="alert" className="alert alert-danger mt-3">
              {errors.other}
            </p>
          )}
        </div>
      )}
    </>
  );
};

export default FormRdv;
